import Vue from 'vue';
import App from './App.vue';
// import './registerServiceWorker';
import router from './router';
import Notifications from 'vue-notification';

// サービスワーカーを削除
// navigator.serviceWorker.getRegistrations().then(function (registrations) {
//   // 登録されているworkerを全て削除する
//   for (const registration of registrations) {
//     registration.unregister();
//   }
// });

// eslint-disable-next-line @typescript-eslint/no-var-requires
const vuejsDatepicker = require('vuejs-datepicker');

const CommonTable = () => import(/* webpackChunkName: "commons" */ './components/organisms/CommonTable.vue');
// import CommonTable from './components/organisms/CommonTable.vue';

const TextField = () => import(/* webpackChunkName: "commons" */ './components/inputs/TextField.vue');
// import TextField from './components/inputs/TextField.vue';
const SelectField = () => import(/* webpackChunkName: "commons" */ './components/inputs/SelectField.vue');
// import SelectField from './components/inputs/SelectField.vue';
const SimpleSelect = () => import(/* webpackChunkName: "commons" */ './components/inputs/SimpleSelect.vue');
// import SimpleSelect from './components/inputs/SimpleSelect.vue';
const SimpleCheckBox = () => import(/* webpackChunkName: "commons" */ './components/inputs/SimpleCheckBox.vue');
// import SimpleCheckBox from './components/inputs/SimpleCheckBox.vue';
const TextArea = () => import(/* webpackChunkName: "commons" */ './components/inputs/TextArea.vue');
// import TextArea from './components/inputs/TextArea.vue';
const CheckBox = () => import(/* webpackChunkName: "commons" */ './components/inputs/CheckBox.vue');
// import CheckBox from './components/inputs/CheckBox.vue';
const ToggleSwitch = () => import(/* webpackChunkName: "commons" */ './components/inputs/ToggleSwitch.vue');
// import ToggleSwitch from './components/inputs/ToggleSwitch.vue';
const CheckBoxGroup = () => import(/* webpackChunkName: "commons" */ './components/inputs/CheckBoxGroup.vue');
//import CheckBoxGroup from './components/inputs/CheckBoxGroup.vue';
const SectionTitle = () => import(/* webpackChunkName: "commons" */ './components/atoms/SectionTitle.vue');
// import SectionTitle from './components/atoms/SectionTitle.vue';
const AdminHeaderNavigation = () => import(/* webpackChunkName: "headers" */ './admin/header/AdminHeaderNavigation.vue');
// import AdminHeaderNavigation from './admin/header/AdminHeaderNavigation.vue';
const TeacherHeaderNavigation = () => import(/* webpackChunkName: "headers" */ './teacher/header/TeacherHeaderNavigation.vue');
// import TeacherHeaderNavigation from './teacher/header/TeacherHeaderNavigation.vue';
const StudentHeaderNavigation = () => import(/* webpackChunkName: "headers" */ './student/header/StudentHeaderNavigation.vue');
// import StudentHeaderNavigation from './student/header/StudentHeaderNavigation.vue';
import RadioGroup from './components/inputs/RadioGroup.vue';
import NoDataPanel from './components/atoms/NoDataPanel.vue';
import Loading from './components/atoms/Loading.vue';
import PrimaryButton from './components/button/PrimaryButton.vue';
import CancelButton from './components/button/CancelButton.vue';
import WhiteBlueButton from './components/button/WhiteBlueButton.vue';
import WhiteBlackSquareButton from './components/button/WhiteBlackSquareButton.vue';
import WhiteBlackButton from './components/button/WhiteBlackButton.vue';
import RedButton from './components/button/RedButton.vue';
import DotIcon from './components/icon/DotIcon.vue';
import HeaderLabel from './components/atoms/HeaderLabel.vue';
import MainDiv from './components/organisms/MainDiv.vue';
import WhiteFrame from './components/atoms/WhiteFrame.vue';
import PlusIcon from './components/icon/PlusIcon.vue';
import PagesMixin from './components/organisms/PagesMixin';
import FooterSection from './components/atoms/FooterSection.vue';
import { SystemService } from './biz/remote/SystemService';
import VueScrollTo from 'vue-scrollto';
import { LocalData } from './utils/LocalData';
// import VueQuill from 'vue-quill'
import CKEditor from 'ckeditor4-vue';

async function versionCheck(): Promise<void> {
  const biz = new SystemService();
  const response = await biz.getVersion();
  if (response.hasError) {
    console.log(response.errorDescription);
    return;
  }
  const sv_version = response.data;
  LocalData.setLocalVersion(sv_version);
}

// async function versionCheck(): Promise<void> {
//   const biz = new SystemService();
//   const response = await biz.getVersion();
//   if (response.hasError) {
//     console.log(response.errorDescription);
//     return;
//   }
//   const sv_version = response.data;
//   const lo_version = LocalData.getLocalVersion(); // packageJson.version;
//   if (sv_version !== lo_version) {
//     console.log(`最新バージョンのアプリが存在するため更新します${sv_version} > ${lo_version}`);
//     LocalData.setLocalVersion(sv_version);
//     location.reload(true);
//   }
//   return;
// }
versionCheck().catch((e) => console.log(e));

// Vue.use(VueQuill)
Vue.use(CKEditor as any);

Vue.use(VueScrollTo);
// You can also pass in the default options
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
});
Vue.mixin(PagesMixin);
Vue.use(Notifications);

Vue.config.productionTip = false;
Vue.component('CommonTable', CommonTable);
Vue.component('TextField', TextField);
Vue.component('SelectField', SelectField);
Vue.component('TextArea', TextArea);

Vue.component('SimpleSelect', SimpleSelect);
Vue.component('SimpleCheckBox', SimpleCheckBox);

Vue.component('AdminHeaderNavigation', AdminHeaderNavigation);
Vue.component('TeacherHeaderNavigation', TeacherHeaderNavigation);
Vue.component('StudentHeaderNavigation', StudentHeaderNavigation);
Vue.component('CheckBox', CheckBox);
Vue.component('ToggleSwitch', ToggleSwitch);
Vue.component('CheckBoxGroup', CheckBoxGroup);
Vue.component('SectionTitle', SectionTitle);
Vue.component('RadioGroup', RadioGroup);
Vue.component('NoDataPanel', NoDataPanel);
Vue.component('Loading', Loading);
Vue.component('FooterSection', FooterSection);

Vue.component('DotIcon', DotIcon);
Vue.component('HeaderLabel', HeaderLabel);
Vue.component('PrimaryButton', PrimaryButton);
Vue.component('CancelButton', CancelButton);
Vue.component('WhiteBlueButton', WhiteBlueButton);
Vue.component('WhiteBlackSquareButton', WhiteBlackSquareButton);
Vue.component('WhiteBlackButton', WhiteBlackButton);
Vue.component('RedButton', RedButton);
Vue.component('MainDiv', MainDiv);
Vue.component('WhiteFrame', WhiteFrame);
Vue.component('PlusIcon', PlusIcon);
Vue.component('vuejs-datepicker', vuejsDatepicker.default);
const app = new Vue({
  router,
  render: (h) => h(App),
});
app.$mount('#app');
